import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "eafbb2ba-4dd3-4f81-9937-29edb7e1bf4d",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Input the Bℓ value (rounded to the first decimal place):",
    suffixText: "T∙m",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 4.3,
};
